import React from "react";
import Options from "./Options";
import ProgressBar from "./ProgressBar";
import "./Question.css";

function Questions({
  questions,
  dispatch,
  answered,
  totalScore,
  setAnswered,
  userPoints,
  questionNumber,
  totalQuestions,
  handleSetUserPoints,
}) {
  return (
    <div className="options">
      <ProgressBar
        totalScore={totalScore}
        userPoints={userPoints}
        questionNumber={questionNumber}
        totalQuestions={totalQuestions}
        answered={answered}
      />
      <h4>{questions.question}</h4>
      <Options
        options={questions.options}
        questions={questions}
        dispatch={dispatch}
        answered={answered}
        setAnswered={setAnswered}
        handleSetUserPoints={handleSetUserPoints}
      />
    </div>
  );
}

export default Questions;
